import { useTrellisFocusRing } from 'foundations-components/hooks/useTrellisFocusRing';
import { useCallback } from 'react';
import { mergeProps } from '@react-aria/utils';
export const useButtonFocusStyles = ({
  disabled = false,
  domProps = {},
  onClick,
  onMouseDown
}) => {
  // Borrowed from how foundations Button handles applying focus ring styles
  // https://sourcegraph.hubteam.com/git.hubteam.com/HubSpot/foundations-components@effbbbcc4fb784e874c9f0d223779df929b30730/-/blob/foundations-components/static/js/components/Button/Button.tsx?L157-159
  const {
    focusProps,
    focusRingStyles
  } = useTrellisFocusRing();
  // Borrowed from how foundations Button handles preventing click events when disabled
  // https://sourcegraph.hubteam.com/git.hubteam.com/HubSpot/foundations-components@effbbbcc4fb784e874c9f0d223779df929b30730/-/blob/foundations-components/static/js/components/Button/Button.tsx?L133-136
  const handleClick = useCallback(evt => {
    if (disabled || !onClick) return;
    onClick(evt);
  }, [disabled, onClick]);
  const handleMouseDown = useCallback(evt => {
    if (disabled || !onMouseDown) return;
    onMouseDown(evt);
  }, [disabled, onMouseDown]);
  // Chain these event handlers rather than overriding
  const mergedProps = mergeProps({
    onClick: handleClick,
    onMouseDown: handleMouseDown
  }, focusProps, domProps);
  return {
    focusRingStyles,
    mergedProps
  };
};

// Borrowed from how foundations Button sets the target based on the external prop
// https://git.hubteam.com/HubSpot/foundations-components/blob/6ad8d70f180d88266a31a318d1f5bcae92735c2e/foundations-components/static/js/transitional/components/Button/Button.utils.tsx#L12
export const getTarget = (external, target) => {
  if (target !== undefined) {
    return target;
  }
  if (external) {
    return '_blank';
  }
  return undefined;
};